import script from "./CollectionCell.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionCell.vue?vue&type=script&setup=true&lang=js"

import "./CollectionCell.vue?vue&type=style&index=0&id=555ae3b2&lang=scss&scoped=true"
script.__scopeId = "data-v-555ae3b2"

export default script